import styled from "@emotion/native";

export const IconContainer = styled.View({
	justifyContent: "center",
	alignItems: "center",
	width: 52,
	height: 52,
	marginRight: 10
});
